import { useEffect, useState } from 'react';
import { useAppDispatch } from 'app/hooks';
import { useHistory } from 'react-router-dom';
import qs from 'qs';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import DebtSection from './components/DebtSection/DebtSection';
import { IVerifyIdentityFormModel } from 'features/payment/types';
import http from 'app/http';
import { getPathnameFromUrl } from 'common/helpers/resolveHost';
import { UrlEncodedHeaders } from 'features/payment/services';
import styles from './VerifyIdentityWithoutDebtReferencePageData.module.scss';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';
import TagManager from 'react-gtm-module';
import { removeCoreData } from 'features/core/reducer';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const VerifyIdentityWithoutDebtReferencePageData = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  const dispatch = useAppDispatch();
  const history = useHistory();
  const [verifyIdentity, setVerifyIdentity] =
    useState<IVerifyIdentityFormModel>({});
  const [eventTracked, setEventTracked] = useState<boolean>(false);
  const [modelState, setModelState] = useState(Model);
  const [pageDataState, setPageDataState] = useState(PageData);
  const [layoutModelState, setLayoutModelState] = useState(LayoutModel);

  var tagManagerArgs: any;
  useEffect(() => {
    if (eventTracked == false) {
      tagManagerArgs = {
        dataLayer: {
          event: 'checkout_step',
          checkout_name: 'Registration',
          checkout_step_number: '1' 
        },
      };
      TagManager.dataLayer(tagManagerArgs);
      setEventTracked(true);
    }
  }, [eventTracked]);

  useEffect(() => {
    if (
      modelState?.VerifyIdentityViewModelWithoutReference
        .ShowAlreadyRegisteredPanel
    ) {
      tagManagerArgs = {
        dataLayer: {
          event: 'form_error',
          checkout_name: 'Registration',
          error_message: 'Already registered',
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }

    if (modelState?.IsPortalAccessDenied) {
      tagManagerArgs = {
        dataLayer: {
          event: 'form_error',
          checkout_name: 'Registration',
          error_message: 'Customer not allowed',
        },
      };
      TagManager.dataLayer(tagManagerArgs);
    }
  }, [modelState]);

  const onVerifyIdentity = async (data: IVerifyIdentityFormModel) => {
    // Keep form data in local state
    setVerifyIdentity(data);
    //Get pathname from url
    const verifyIdentityUrl = getPathnameFromUrl(
      Model?.PostVerifyIdentityWithoutDebtReferencePageUrl,
    );
    // Verification request
    try {
      const response = await http.post(
        verifyIdentityUrl,
        qs.stringify({ FormModel: data.VerifyIdentityFormModel }),
        UrlEncodedHeaders,
      );
      if (response && response.data) {
        // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
        var nextPagePath = '';
        if (!response.data.RedirectUrl) {
          setModelState(response.data.Model);
          setPageDataState(response.data.PageData);
          setLayoutModelState(response.data.LayoutModel);
        } else {
          nextPagePath = getPathnameFromUrl(response.data.RedirectUrl);
          dispatch(removeCoreData());
          history.push(nextPagePath, {
            noRefresh: false,
          });
        }

        // Add response to store
        //dispatch(setContent({ [nextPagePath]: response.data.RedirectUrl }));
        // Redirect to next step path
      }
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    if (LayoutModel != undefined) {
      var userid =
        LayoutModel?.Profiles.length > 0
          ? LayoutModel?.Profiles[0].DebtReference
          : '';
      var isLoggedIn = LayoutModel?.HasProfile;
      var lang = PageData?.Language;
      var env = LayoutModel?.Environment;
      var reg = LayoutModel?.CountryCode;
      getGTMVariables(userid, isLoggedIn, lang, reg, env);
      getGTMVariablesPageView(
        window.document.title,
        window.location.href,
        window.location.pathname,
        userid,
        isLoggedIn,
        lang,
        reg,
        env,
      );
    }
  }, [LayoutModel]);

  return (
    <>
      {Model?.VerifyIdentityViewModelWithoutReference?.FormModel
        ?.IsDisableRecaptcha ? (
        <>
          <div className="u-marginBxxsm u-marginTxxsm">
            <div className="step-wizard">
              <div className="step-wizard-container">
                <a onClick={() => history.go(-1)}>
                  <img
                    src="/assets/images/icons/Chevron.svg"
                    className="u-hidden"
                  />
                </a>
                <p className="u-textCenter">
                  {
                    Model?.VerifyIdentityViewModelWithoutReference?.PageData
                      ?.StepText
                  }{' '}
                  <span className="u-textWeightBold">1</span>{' '}
                  {
                    Model?.VerifyIdentityViewModelWithoutReference?.PageData
                      ?.OfText
                  }{' '}
                  <span className="u-textWeightBold">4</span>
                </p>
                <a
                  id="cancelregistration"
                  data-modal-url={
                    Model?.VerifyIdentityViewModelWithoutReference
                      ?.CancelRegistrationPageUrl
                  }
                >
                  <img
                    src="/assets/images/icons/CloseIcon.svg"
                    className="u-hidden"
                  />
                </a>
              </div>
            </div>
          </div>
          <div className={styles.section}></div>
          <DebtSection
            Model={modelState}
            PageData={pageDataState}
            LayoutModel={layoutModelState}
            onVerifyIdentity={onVerifyIdentity}
          />
        </>
      ) : (
        <>
          <GoogleReCaptchaProvider
            reCaptchaKey={
              Model?.VerifyIdentityViewModelWithoutReference?.ReCaptchaKey
            }
          >
            <div className="u-marginBxxsm u-marginTxxsm">
              <div className="step-wizard">
                <div className="step-wizard-container">
                  <a onClick={() => history.go(-1)}>
                    <img
                      src="/assets/images/icons/Chevron.svg"
                      className="u-hidden"
                    />
                  </a>
                  <p className="u-textCenter">
                    {
                      Model?.VerifyIdentityViewModelWithoutReference?.PageData
                        ?.StepText
                    }{' '}
                    <span className="u-textWeightBold">1</span>{' '}
                    {
                      Model?.VerifyIdentityViewModelWithoutReference?.PageData
                        ?.OfText
                    }{' '}
                    <span className="u-textWeightBold">4</span>
                  </p>
                  <a
                    id="cancelregistration"
                    data-modal-url={
                      Model?.VerifyIdentityViewModelWithoutReference
                        ?.CancelRegistrationPageUrl
                    }
                  >
                    <img
                      src="/assets/images/icons/CloseIcon.svg"
                      className="u-hidden"
                    />
                  </a>
                </div>
              </div>
            </div>
            <div className={styles.section}></div>
            <DebtSection
              Model={modelState}
              PageData={pageDataState}
              LayoutModel={layoutModelState}
              onVerifyIdentity={onVerifyIdentity}
            />
          </GoogleReCaptchaProvider>
        </>
      )}
    </>
  );
};

export default VerifyIdentityWithoutDebtReferencePageData;
